import React from 'react';
import { Box } from '@atlaskit/primitives/compiled';
export var Breadcrumbs = function Breadcrumbs() {
  return /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Image, null));
};
var Image = function Image() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 203,
    height: 20,
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 6,
    y: 7,
    fill: "#454F59",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 6,
    x: 113,
    y: 7,
    fill: "#454F59",
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6B778C",
    d: "m108.701 4.664-3.014 12.81h-1.395l3.015-12.81h1.394Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BFDBF8",
    fillOpacity: 0.28,
    fillRule: "evenodd",
    d: "M195 2a.75.75 0 0 1 .7.48l1.705 4.434 4.403.338a.75.75 0 0 1 .422 1.324l-3.381 2.818 1.25 4.662a.748.748 0 0 1-1.148.813L195 14.159l-3.951 2.71a.75.75 0 0 1-1.148-.813l1.25-4.662-3.381-2.818a.749.749 0 0 1 .423-1.324l4.402-.338L194.3 2.48A.75.75 0 0 1 195 2Zm0 2.84-1.345 3.496-3.506.27 2.7 2.25-.973 3.627L195 12.341l3.124 2.142-.973-3.627 2.7-2.25-3.506-.27L195 4.84Z",
    clipRule: "evenodd"
  }));
};